import { format, parse } from 'date-fns';

import { HourlyCookedWeightData } from '../types';

export interface WeightChangeData {
  latestHourWeight: number;
  comparedWeight: number;
  difference: number;
  isIncrease: boolean;
  isDecrease: boolean;
  isSame: boolean;
  hasData: boolean;
}

export const getTargetTimestamp = (selectedTimestamp: string): string => {
  const date = parse(selectedTimestamp, 'dd-MMM-yyyy h:mm a', new Date());

  return format(date, 'dd-MM-yyyy-HH:mm');
};

export const calculateWeightChange = (
  hourlyData: HourlyCookedWeightData[] | null | undefined,
  selectedTimestamp: string,
  totalCookedWeight?: number | null
): WeightChangeData => {
  if (!selectedTimestamp) {
    return {
      latestHourWeight: 0,
      comparedWeight: 0,
      difference: 0,
      isIncrease: false,
      isDecrease: false,
      isSame: false,
      hasData: false
    };
  }
  if (!hourlyData || hourlyData.length === 0) {
    return {
      latestHourWeight: 0,
      comparedWeight: 0,
      difference: 0,
      isIncrease: false,
      isDecrease: false,
      isSame: false,
      hasData: false
    };
  }
  const currentWeight = hourlyData[hourlyData.length - 1]?.weight || 0;

  let pastWeight: number;

  const targetTimestamp = getTargetTimestamp(selectedTimestamp);
  const exactMatch = hourlyData.find((data) => data.timestamp === targetTimestamp);

  if (exactMatch) {
    pastWeight = exactMatch.weight;
  } else if (totalCookedWeight === null || totalCookedWeight === undefined) {
    return {
      latestHourWeight: currentWeight,
      comparedWeight: 0,
      difference: 0,
      isIncrease: false,
      isDecrease: false,
      isSame: false,
      hasData: false
    };
  } else {
    pastWeight = totalCookedWeight;
  }

  const change = currentWeight - pastWeight;

  return {
    latestHourWeight: currentWeight,
    comparedWeight: pastWeight,
    difference: Math.abs(change),
    isIncrease: change > 0,
    isDecrease: change < 0,
    isSame: change === 0,
    hasData: true
  };
};
